import { render, staticRenderFns } from "./user_menu.vue.js?vue&type=template&id=34406e3f!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu.vue?vue&type=template&id=34406e3f"
import script from "./user_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu.vue?vue&type=script&lang=js"
export * from "./user_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34406e3f')) {
      api.createRecord('34406e3f', component.options)
    } else {
      api.reload('34406e3f', component.options)
    }
    module.hot.accept("./user_menu.vue.js?vue&type=template&id=34406e3f!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu.vue?vue&type=template&id=34406e3f", function () {
      api.rerender('34406e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/user_menu.vue"
export default component.exports